module.exports = __webpack_public_path__ + "static/media/problem-definition-large@2x.4a56ccb0.png";